import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal, Table, Typography } from 'antd';
import { FC } from 'react';

import { IUnassignedLocationEntry } from '../../../hooks/useRecruiterStats';

const { Text, Title } = Typography;

interface IUnassignedLocationsModalProps {
  visible: boolean;
  onClose: () => void;
  locations: IUnassignedLocationEntry[];
}

const columns = [
  {
    title: 'Location Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Region',
    dataIndex: 'regionName',
    key: 'regionName',
    render: (val: string | undefined) => val ?? '—',
  },
];

const TABLE_DARK_STYLES = `
  .unassigned-locations-table .ant-table {
    background: #0b345f;
    color: #cedbef;
    border-radius: 6px;
  }
  .unassigned-locations-table .ant-table-thead > tr > th {
    background: #0a2a4f;
    color: #cedbef;
    border-bottom: 1px solid rgba(255,255,255,0.12);
    font-weight: 600;
  }
  .unassigned-locations-table .ant-table-tbody > tr > td {
    background: #0b345f;
    color: #cedbef;
    border-bottom: 1px solid rgba(255,255,255,0.08);
  }
  .unassigned-locations-table .ant-table-tbody > tr:hover > td {
    background: #0d3f72;
  }
  .unassigned-locations-table .ant-table-tbody > tr:nth-child(even) > td {
    background: #0d3f72;
  }
  .unassigned-locations-table .ant-table-tbody > tr:nth-child(even):hover > td {
    background: #10497f;
  }
`;

const BORDER_RADIUS = 8;

const UnassignedLocationsModal: FC<IUnassignedLocationsModalProps> = ({
  visible,
  onClose,
  locations,
}) => {
  return (
    <>
      <style>{TABLE_DARK_STYLES}</style>
      <Modal
        visible={visible}
        onCancel={onClose}
        footer={null}
        width={660}
        bodyStyle={{
          background: '#0e4d8f',
          borderRadius: BORDER_RADIUS,
          padding: 24,
        }}
        style={{ borderRadius: BORDER_RADIUS }}
        className="unassigned-locations-modal"
        closable
        closeIcon={<CloseOutlined style={{ color: '#cedbef', fontSize: 16 }} />}
        destroyOnClose
        wrapClassName="unassigned-locations-modal-wrap"
      >
        <style>{`
          .unassigned-locations-modal .ant-modal-content {
            border-radius: ${BORDER_RADIUS}px;
            overflow: hidden;
          }
        `}</style>
        <Title level={4} style={{ color: '#fff', marginBottom: 4 }}>
          Unassigned Locations ({locations.length})
        </Title>
        <Text style={{ color: '#cedbef', display: 'block', marginBottom: 16 }}>
          These locations have no recruiter assigned. Assign them in User
          Management → Assigned Locations.
        </Text>
        <div className="unassigned-locations-table">
          <Table
            dataSource={locations}
            columns={columns}
            rowKey="id"
            pagination={false}
            size="small"
            scroll={{ y: 400 }}
            style={{ borderRadius: 6 }}
          />
        </div>
        <div
          style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}
        >
          <Button
            onClick={onClose}
            style={{
              background: '#1a5a8a',
              borderColor: '#2a6a9a',
              color: '#fff',
            }}
          >
            Close
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default UnassignedLocationsModal;
